<template>
	<section class="form-group FormInput" :data-entry="id || name">
		<label v-if="label" class="title" :for="`${formId}_${id || name}${Array.isArray(value) ? '_0' : ''}`" :class="{ required }">{{
			label
		}}</label>
		<div v-if="Array.isArray(value)" class="input-group">
			<template v-for="(v, i) in value">
				<div :key="`v_${i}`" class="input-area">
					<i v-if="icon" :class="{ [`icon-${icon}`]: true }"></i>
					<input
						ref="input"
						v-if="!multiline"
						class="input"
						:type="type"
						:id="`${formId}_${id || name}${Array.isArray(value) ? `_${i}` : ''}`"
						v-bind="getAttrs(i)"
						:value="v"
						@input="onInput($event, i)"
					/>
					<textarea
						v-else
						class="input"
						:id="`${formId}_${id || name}${Array.isArray(value) ? `_${i}` : ''}`"
						v-bind="getAttrs(i)"
						:value="v"
						@input="onInput($event, i)"
					></textarea>
					<A v-if="updateButton" class="update-button" @click="$emit('change', $refs.input.value)">{{ updateButton }}</A>
				</div>
				<span :key="`separator_${i}`" v-if="Array.isArray(value) && i < value.length - 1" class="separator"></span>
			</template>
		</div>
		<div v-else class="input-area">
			<i v-if="icon" :class="{ [`icon-${icon}`]: true }"></i>
			<input
				ref="input"
				v-if="!multiline"
				class="input"
				:type="type"
				:id="`${formId}_${id || name}`"
				v-bind="$attrs"
				:value="value"
				@input="onInput"
			/>
			<textarea v-else class="input" :id="`${formId}_${id || name}`" v-bind="$attrs" :value="value" @input="onInput"></textarea>
			<a v-if="updateButton" href="javascript" class="update-button" @click.prevent.stop="$emit('change', $refs.input.value)">{{
				updateButton
			}}</a>
		</div>
	</section>
</template>

<script>
	import mixin from './mixin';
	export default {
		mixins: [mixin],
		props: {
			multiline: {
				type: Boolean,
				default: false
			},
			updateButton: {
				type: String,
				default: ''
			}
		},
		methods: {
			onInput(e, i) {
				if (!this.updateButton) {
					if (i !== undefined) {
						const values = [...this.value];
						values[i] = e.target.value;
						this.$emit('change', values);
					} else {
						this.$emit('change', e.target.value);
					}
				}

				if (e.target.getAttribute('maxlength') && i !== undefined && e.target.value.length >= e.target.getAttribute('maxlength')) {
					e.target.parentElement.nextElementSibling?.nextElementSibling.querySelector('.input').focus();
					e.target.parentElement.nextElementSibling?.nextElementSibling.querySelector('.input').select();
				}
			},
			getAttrs(i) {
				return Object.fromEntries(Object.entries(this.$attrs).map(([k, v]) => [k, Array.isArray(v) ? v[i] : v]));
			}
		}
	};
</script>

<style scoped lang="scss">
	.FormInput {

		.input-group {
			display: flex;
			align-items: center;
		}

		.input-area {
			display: flex;

			.input {
				outline: none;
				border: none;
				padding: 1rem 1.5rem;
				background-color: var(--backgroundColor);
				border-radius: 0.5rem;
				font-size: inherit;
			}

			input {
			}

			textarea {
			}

			.update-button {
				background-color: var(--color);
				color: white !important;
				border-radius: 0.5rem;
				display: flex;
				align-items: center;
				justify-content: center;
				margin-left: 1rem;
				flex: 0 1 10rem;
				transition: filter 0.2s;

				&:hover {
					filter: brightness(1.5);
				}
			}
		}
	}
</style>
